import clsx from "clsx";

import { FieldValidationToggle } from "../field-validation-toggle";

type PreviewFormFooterProps = {
  previewErrorToggle: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
};

export const PreviewFormFooter = ({
  previewErrorToggle,
}: PreviewFormFooterProps) => (
  <div className="flex h-[5.6rem] w-full bottom-0 absolute bg-white">
    <div className={clsx("flex items-center z-modal ml-[6rem]")}>
      <FieldValidationToggle
        toggled={previewErrorToggle[0]}
        onClick={() => previewErrorToggle?.[1](!previewErrorToggle[0])}
      />
    </div>
  </div>
);
